// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import { Alert } from "antd";
import PropTypes from "prop-types";
import { SERVER_ERROR_MESSAGES, DISPLAY_ERROR_MESSAGES } from "../constants/errorMessages";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'error' implicitly has an 'any' type.
function ShowError({ error, ...props }) {
  if (error) {
    props.message = getErrorMessage(error.message, props.message);
    return <Alert {...props} />;
  } else {
    return null;
  }
}
// function can be changed to switch when more conditions need to be processed
// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'error' implicitly has an 'any' type.
const getErrorMessage = (error, message) => {
  return error.includes(SERVER_ERROR_MESSAGES.AUTHENTICATION_FAILURE)
    ? DISPLAY_ERROR_MESSAGES.TRY_AGAIN
    : message;
};

ShowError.propTypes = {
  error: PropTypes.object,
};

ShowError.defaultProps = {
  type: "error",
};

export { ShowError };
